import { PLATFORM_CONTRACT_VERSION, PlatformError, type PlatformServices } from '@auw/platform-contracts';

async function unsupported(): Promise<never> {
  throw new PlatformError('NOT_SUPPORTED', '로컬 프로젝트는 데스크톱 앱에서 열 수 있습니다.');
}
export function createWebPlatform(): PlatformServices {
  return {
    kind: 'web',
    runtimeInfo: async () => ({
      contractVersion: PLATFORM_CONTRACT_VERSION,
      appVersion: 'web',
      os: 'web',
      capabilities: { localProjects: false, readText: false, writeFiles: false, centralAgents: true },
    }),
    projects: { open: unsupported, list: unsupported, readText: unsupported, close: unsupported },
  };
}
